module.exports = __webpack_public_path__ + "img/explain.a923941e.png";